import { FC } from "react"
import BaseIconButton, { IIconButtonProps } from "../BaseIconButton"
import {
    ReadyForReplicationIcon,
    SyncCentralOfficeToCompanyIcon
} from "../../../../libs/corporate/icons/outlined/other/CompanyReplicationCollection"

export const ReadyForReplicationButton: FC<IIconButtonProps> = (props) => {
    return (
        <BaseIconButton {...props}>
            <ReadyForReplicationIcon />
        </BaseIconButton>
    )
}

export const SyncCentralOfficeToCompanyButton: FC<IIconButtonProps> = (props) => {
    return (
        <BaseIconButton {...props}>
            <SyncCentralOfficeToCompanyIcon />
        </BaseIconButton>
    )
}
